/**
 * SitePick front — iframe 埋め込みの共通処理（Preview / 詳細ページのデバイス枠で共有）。
 *
 * promoteIframe: `data-sp-src` を `src` へ昇格し、load / timeout を扱う。
 * 高さ追従・postMessage は使わない（docs/07 §1 / §15）。
 */

const DEFAULT_TIMEOUT_MS = 9000;

/**
 * iframe の src を `data-sp-src` から 1 回だけ昇格させる。
 *
 * @param {HTMLIFrameElement} iframe
 * @param {Object} [opts]
 * @param {HTMLElement|null} [opts.loading]  読み込み中に表示、load / timeout で hidden
 * @param {HTMLElement|null} [opts.fallback] timeout 時に表示（iframe は消さない）
 * @param {Function} [opts.onLoad]           load 成功時（計測はここで行う）
 * @param {Function} [opts.onTimeout]        timeout 時（load が来なかった）
 * @param {number} [opts.timeout]
 * @returns {boolean} 昇格したら true（既に昇格済みなら false）
 */
export function promoteIframe(iframe, opts = {}) {
  const src = iframe && iframe.getAttribute("data-sp-src");
  if (!src || iframe.dataset.spPromoted === "1") {
    return false;
  }
  iframe.dataset.spPromoted = "1";

  const { loading = null, fallback = null, onLoad = null, onTimeout = null } = opts;
  const timeoutMs = Number.isFinite(opts.timeout) ? opts.timeout : DEFAULT_TIMEOUT_MS;

  let settled = false;
  const finish = () => {
    if (settled) {
      return;
    }
    settled = true;
    window.clearTimeout(timer);
    if (loading) {
      loading.hidden = true;
    }
    if (typeof onLoad === "function") {
      onLoad();
    }
  };

  iframe.addEventListener("load", () => {
    if (iframe.dataset.spPromoted === "1") {
      finish();
    }
  });

  const timer = window.setTimeout(() => {
    if (settled) {
      return;
    }
    // load が来ないまま時間切れ。以後 load が来ても「成功」とはみなさない
    // （成功と失敗の両方を数えないため）。
    settled = true;
    if (loading) {
      loading.hidden = true;
    }
    if (fallback) {
      fallback.hidden = false;
    }
    if (typeof onTimeout === "function") {
      onTimeout();
    }
  }, timeoutMs);

  iframe.setAttribute("src", src);
  return true;
}
